import { useState } from 'react';
import { PayoutResult, PerformanceReportDataSourceEnum } from 'types/enums.ts';

interface UseReportDataSourceToggleReturn {
    actualSource: PerformanceReportDataSourceEnum;
    actualStatuses: PayoutResult[];
    toggleSource: () => void;
    toggleStatuses: (statuses: PayoutResult[]) => void;
}

export const useReportDataSourceToggle = (
    initialSource: PerformanceReportDataSourceEnum = PerformanceReportDataSourceEnum.ReportPayoutPerformances,
    initialStatuses: PayoutResult[] = [PayoutResult.Approved]
): UseReportDataSourceToggleReturn => {
    const [actualSource, setActualSource] = useState<PerformanceReportDataSourceEnum>(initialSource);
    const [actualStatuses, setActualStatuses] = useState<PayoutResult[]>(initialStatuses);

    const toggleSource = () => {
        setActualSource((prev) =>
            prev === PerformanceReportDataSourceEnum.ReportPayoutPerformances
                ? PerformanceReportDataSourceEnum.ReportPerformances
                : PerformanceReportDataSourceEnum.ReportPayoutPerformances
        );
    };

    const toggleStatuses = (statuses: PayoutResult[]) => {
        setActualStatuses(statuses);
    };

    return {
        actualSource,
        actualStatuses,
        toggleSource,
        toggleStatuses,
    };
};